var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.2495 17.4856C35.2495 18.3975 35.0721 18.8989 34.8386 19.1653C34.574 19.4598 34.1351 19.6071 33.3724 19.6071H32.0836V11.8889H33.3755C34.1382 11.8889 34.5771 12.0644 34.8417 12.3307C35.0752 12.5658 35.2526 12.9794 35.2526 13.7754V17.4856H35.2495ZM38.8575 9.17826C38.0948 8.41365 37.0395 8 35.1343 8H27.3333V31.3333H32.0836V23.496H35.1343C37.0395 23.496 38.0979 23.0824 38.8575 22.3178C39.589 21.5813 39.9999 20.5504 39.9999 18.6639V12.8321C39.9999 10.9457 39.5921 9.91467 38.8575 9.17826Z",
    fill: "#058FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.53874 8.00957C5.42457 6.65975 4.92662 5.87794 4.92662 4.97806C4.92662 4.19944 5.4837 3.65696 6.36446 3.65696C7.24521 3.65696 7.80229 4.19625 7.80229 5.27802V8.39888H12.5515V5.57798C12.5515 3.59633 11.9353 2.18907 10.8803 1.25728C9.88124 0.36059 8.38428 0 6.36134 0C4.36642 0 2.93169 0.42122 1.9638 1.17112C0.731367 2.09972 0.118263 3.5708 0.118263 5.28121C0.118263 7.7128 1.02703 9.002 2.49287 10.7411L6.33333 15.3331C7.2421 16.4116 7.85831 17.4041 7.85831 18.6326C7.85831 19.7718 7.30123 20.343 6.30532 20.343C5.30942 20.343 4.75233 19.7431 4.75233 18.5433V14.8799H0V18.2401C0 20.2505 0.497953 21.6609 1.40672 22.5289C2.46175 23.5181 4.01474 24 6.30221 24C8.35315 24 9.93726 23.4607 11.0234 22.5002C12.0785 21.5397 12.6667 20.2218 12.6667 18.2401C12.6667 15.8085 11.6396 14.1013 10.1738 12.359L6.53874 8.00957Z",
    fill: "#058FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.2048 22.7909L18.0415 8H13.3333L17.1352 31.3333H22.8646L26.6666 8H22.368L20.2048 22.7909Z",
    fill: "#058FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.548b534fb36fa67416aa1e5234d5aaea.svg";
export { ForwardRef as ReactComponent };